// react
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// UI
import { message, Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { CardElement } from "../../../../components/Common/UIElements";
import {
  ButtonPrimary,
  Button,
} from "../../../../components/Common/Button/index";

// processing
import { addPropertyDraftSchema } from "../../../../schema/onboarding-properties.schema";
import { simpleStringDecode } from "../../../../utils/common-utils";
import useQuery from "../../../../hooks/url.hooks";
import { useAddProperty } from "../../../../hooks/Onboarding/onboarding-properties.hooks";
import PropertyUploader from "../../../../components/Onboarding/PropertyUploader/PropertyUploader";

const AddProperty = () => {
  const history = useHistory();

  // get customer from url
  const query = useQuery();
  const customerId = simpleStringDecode(query.get("customer_id"));
  const allowedProperties = Number(
    simpleStringDecode(query.get("allowed_properties")),
  );
  const uploadedProperties = Number(
    simpleStringDecode(query.get("uploaded_properties")),
  );

  const {
    handleSubmit,
    control,
    reset,
    getValues,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(addPropertyDraftSchema),
  });

  useEffect(() => {
    if (customerId) {
      reset({
        customer_id: customerId,
        allowedNumberOfProperties: allowedProperties - uploadedProperties,
      });
    }
  }, [customerId, allowedProperties, uploadedProperties]);

  // approve/update hooks
  const { mutateAsync: addProperty } = useAddProperty({
    onSuccess: () => {
      history.push(
        "/onboarding/dashboard?msg=Property details updated successfully",
      );
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const savePropertyDetails = (formData) => {
    const { propertyData } = formData;
    addProperty({ propertyData, customerId });
  };

  const clickCancel = () => {
    history.push("/onboarding/dashboard");
  };

  return (
    <>
      <CardElement title="System Discovery">
        <Row>
          <Col span={1} offset={23}>
            <div onClick={clickCancel}>
              <CloseOutlined />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <PropertyUploader
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              customer={customerId}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              style={{ width: "150px" }}
              htmlType="button"
              onClick={clickCancel}
            >
              Cancel
            </Button>
            <ButtonPrimary
              style={{ width: "150px" }}
              onClick={handleSubmit(savePropertyDetails)}
              disabled={getValues("property_contact.email")}
            >
              Save
            </ButtonPrimary>
          </Col>
        </Row>
      </CardElement>
    </>
  );
};

export default AddProperty;
